<app-navbar />
<div class="container-fluid">
  <div class="panel modern-card">
    <div class="panel-header modern-header">
      <h2>
        <i class="fas fa-users me-2"></i>
        Lista de Colaboradores
      </h2>
    </div>
    <div class="panel-body">
      <!-- Formulário de filtros -->
      <div class="filtro-form modern-form">
        <div class="filter-container">
          <div class="form-group">
            <label for="filterType">
              <i class="fas fa-filter me-1"></i> Filtrar por
            </label>
            <select id="filterType" [(ngModel)]="filterType" class="form-control filter-select">
              <option value="nome">Nome</option>
              <option value="cpf">CPF</option>
              <option value="matricula">Matrícula</option>
              <option value="empresaNome">Empresa</option>
            </select>
          </div>
          <div class="form-group">
            <label for="searchTerm">
              <i class="fas fa-search me-1"></i> Termo de Pesquisa
            </label>
            <!-- Se filtro for nome, mostrar select com nomes -->
            <ng-container *ngIf="filterType === 'nome'; else inputSearchTerm">
              <select
                id="searchTerm"
                [(ngModel)]="searchTerm"
                (change)="applyFilter()"
                class="form-control filter-input"
                placeholder="Selecione um colaborador..."
              >
                <option value="">Selecione...</option>
                <option *ngFor="let colaborador of colaboradores" [value]="colaborador.nome">
                  {{ colaborador.nome }}
                </option>
              </select>
            </ng-container>
            <!-- Se filtro não for nome, mostrar input normal -->
            <ng-template #inputSearchTerm>
              <input
                id="searchTerm"
                type="text"
                [(ngModel)]="searchTerm"
                (input)="applyFilter()"
                class="form-control filter-input"
                placeholder="Digite para pesquisar..."
              />
            </ng-template>
          </div>
          <div class="form-buttons modern-buttons">
            <button class="btn btn-secondary" (click)="resetFilters()" title="Limpar filtros">
              <i class="fas fa-eraser me-1"></i> Limpar
            </button>
          </div>
        </div>
      </div>

      <!-- Loading spinner -->
      <div *ngIf="isLoading" class="carregando-container modern-loader">
        <div class="modern-spinner"></div>
        <p>Carregando colaboradores...</p>
      </div>

      <!-- No results message -->
      <div *ngIf="!isLoading && filteredColaboradores.length === 0" class="sem-resultados modern-empty">
        <i class="fas fa-info-circle"></i>
        <p>Nenhum colaborador encontrado com os filtros aplicados.</p>
      </div>

      <!-- Table of collaborators -->
      <div *ngIf="!isLoading && filteredColaboradores.length > 0" class="table-container modern-table-container">
        <!-- Botão de exportação -->
        <div class="data-info mb-3 position-relative d-flex align-items-center">
          <i class="bi bi-people-fill me-1 text-primary"></i>
          <span class="text-muted">
            Exportar lista de colaboradores
          </span>
          <button class="btn btn-icon-export ms-2 exportar" (click)="toggleExportMenu()" title="Exportar">
            <div class="download-wrapper" [class.animando]="exportIconAnimando" [class.ok]="exportIconOk">
              <i *ngIf="!exportIconOk" class="bi bi-arrow-down download-seta"></i>
              <div *ngIf="!exportIconOk" class="download-base"></div>
              <i *ngIf="exportIconOk" class="bi bi-check-circle-fill download-ok"></i>
            </div>
          </button>
          <div class="export-menu" *ngIf="exportMenuAberto">
            <button class="dropdown-item" (click)="exportarCSV(); toggleExportMenu()">
              <i class="bi bi-file-earmark-spreadsheet me-1"></i> Exportar CSV
            </button>
            <button class="dropdown-item" (click)="exportarExcel(); toggleExportMenu()">
              <i class="bi bi-file-earmark-excel me-1"></i> Exportar Excel
            </button>
          </div>
        </div>
  <div class="table-responsive">
  <table class="table table-striped modern-table">
          <thead>
            <tr>
              <th scope="col" class="sortable" (click)="sortBy('nome')">
                <span class="th-icon-label">
                  <i class="fas fa-user"></i>
                  <span>Colaborador</span>
                  <i class="bi" [ngClass]="getSortIcon('nome')"></i>
                </span>
              </th>
              <th scope="col" class="sortable" (click)="sortBy('email')">
                <span class="th-icon-label">
                  <i class="fas fa-envelope"></i>
                  <span>Email</span>
                  <i class="bi" [ngClass]="getSortIcon('email')"></i>
                </span>
              </th>
              <th scope="col" class="sortable" (click)="sortBy('cpf')">
                <span class="th-icon-label">
                  <i class="fas fa-id-card"></i>
                  <span>CPF</span>
                  <i class="bi" [ngClass]="getSortIcon('cpf')"></i>
                </span>
              </th>
              <th scope="col" class="sortable" (click)="sortBy('matricula')">
                <span class="th-icon-label">
                  <i class="fas fa-hashtag"></i>
                  <span>Nº Funcional</span>
                  <i class="bi" [ngClass]="getSortIcon('matricula')"></i>
                </span>
              </th>
              <th scope="col" class="sortable" (click)="sortBy('empresaNome')">
                <span class="th-icon-label">
                  <i class="fas fa-building"></i>
                  <span>Empresa</span>
                  <i class="bi" [ngClass]="getSortIcon('empresaNome')"></i>
                </span>
              </th>
              <th>
                <span class="th-icon-label">
                  <i class="fas fa-cogs"></i>
                  <span>Ações</span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let colaborador of filteredColaboradores">
              <td>
                <a class="collaborator-link" [routerLink]="['/admin/roteiro-colaborador']" [queryParams]="{usuarioId: colaborador.usuarioId}">
                  <img
                    [src]="colaborador.fotoUrl"
                    [alt]="colaborador.nome"
                    class="tecnico-foto rounded-circle"
                    style="width: 40px; height: 40px;"
                  />
                  <span class="collaborator-name">{{ colaborador.nome }}</span>
                </a>
              </td>
              <td><span class="dados-text">{{ colaborador.email }}</span></td>
              <td><span class="cpf-text">{{ formatarCPF(colaborador.cpf) }}</span></td>
              <td><span class="dados-text">{{ colaborador.matricula }}</span></td>
              <td><span class="dados-text">{{ colaborador.empresaNome }}</span></td>
              <td class="text-center actions-cell">
                <div class="btn-group action-buttons" style="gap:0;">
                  <a [routerLink]="isSuperAdmin ? ['/admin/editar-colaborador', colaborador.usuarioId] : null"
                    class="btn btn-sm btn-primary btn-action" 
                    [class.super-admin-enabled]="isSuperAdmin"
                    [class.disabled]="!isSuperAdmin"
                    [title]="isSuperAdmin ? 'Editar colaborador' : 'Somente SuperAdministrador pode editar usuários'">
                    <i class="bi bi-pencil-square"></i>
                  </a>
                  <button class="btn btn-sm btn-danger btn-action" 
                          [class.super-admin-enabled]="isSuperAdmin"
                          [disabled]="!isSuperAdmin" 
                          (click)="abrirModalExclusao(colaborador)" 
                          [title]="isSuperAdmin ? 'Excluir colaborador' : 'Somente SuperAdministrador pode excluir usuários'">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
  </table>
  </div>
        <!-- Paginação igual ao consumidor -->
        <div class="pagination-container">
          <div class="pagination-bottom-bar">
            <div class="pagination-info">
              Mostrando {{filteredColaboradores.length}} de {{totalColaboradores}} registros | Página {{paginaAtual}} de {{totalPaginas}}
            </div>
            <nav aria-label="Navegação de páginas" class="pagination-nav">
              <ul class="pagination mb-0">
                <li class="page-item" [class.disabled]="paginaAtual === 1">
                  <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(1)" aria-label="Primeira">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <li class="page-item" [class.disabled]="paginaAtual === 1">
                  <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(paginaAtual - 1)" aria-label="Anterior">
                    <span aria-hidden="true">&lsaquo;</span>
                  </a>
                </li>
                <ng-container *ngFor="let pagina of paginasVisiveis()">
                  <li class="page-item" [class.active]="pagina === paginaAtual">
                    <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(pagina)">
                      {{pagina}}
                    </a>
                  </li>
                </ng-container>
                <li class="page-item" [class.disabled]="paginaAtual === totalPaginas || totalPaginas === 0">
                  <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(paginaAtual + 1)" aria-label="Próxima">
                    <span aria-hidden="true">&rsaquo;</span>
                  </a>
                </li>
                <li class="page-item" [class.disabled]="paginaAtual === totalPaginas || totalPaginas === 0">
                  <a class="page-link" href="#" (click)="$event.preventDefault(); mudarPagina(totalPaginas)" aria-label="Última">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav>
            <div class="pagination-size">
              <label for="itensPorPagina" class="me-2 mb-0">Itens por página:</label>
              <select id="itensPorPagina" [(ngModel)]="itensPorPagina" (change)="mudarItensPorPagina()" class="form-select d-inline-block w-auto">
                <option [ngValue]="5">5</option>
                <option [ngValue]="10">10</option>
                <option [ngValue]="20">20</option>
                <option [ngValue]="50">50</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation Modal for Deletion -->
<div *ngIf="colaboradorSelecionado" class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">Confirmação de Exclusão</h5>
        <button type="button" class="close btn-close" (click)="fecharModalExclusao()"></button>
      </div>
      <div class="modal-body text-center">
        <p>Tem certeza que deseja excluir este colaborador?</p>
        <strong>{{ colaboradorSelecionado.nome }}</strong>
      </div>
      <div class="modal-footer d-flex justify-content-between">
        <button type="button" class="btn btn-secondary w-45" (click)="fecharModalExclusao()">
          Não
        </button>
        <button type="button" class="btn btn-danger w-45" (click)="excluirColaborador()">
          Sim
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="colaboradorSelecionado" class="modal-backdrop fade show"></div>